import {
  ICustomerOrganization,
  ICustomerProfileState,
  IHeaderState,
  IStatusState,
} from '@app/shared/models/header.model';
import {HeaderUtils} from '@app/shared/utils/header.utils';
import {EState} from '@app/state/reducers';
import {createFeatureSelector, createSelector} from '@ngrx/store';

export const selectHeaderState = createFeatureSelector<IHeaderState>(EState.Header);

export const selectOrganizations = createSelector(
  selectHeaderState,
  (state: IHeaderState) => state?.customerProfileState?.customerOrganizations ?? null
);

export const selectUserName = createSelector(selectHeaderState, (state: IHeaderState) => {
  const firstName = state?.customerProfileState?.firstName ?? '';
  const lastName = state?.customerProfileState?.lastName ?? '';
  if (firstName || lastName) {
    return lastName + ' ' + firstName;
  } else {
    return null;
  }
});

export const selectCustomerOrganizationStatus = createSelector(
  selectHeaderState,
  (state: IHeaderState) => state.accountStatus
);

export const selectCustomerProfile = createSelector(
  selectHeaderState,
  (state: IHeaderState) => state?.customerProfileState
);

export const selectCustomerRole = createSelector(
  selectHeaderState,
  (state: IHeaderState) => state?.customerProfileState?.roleId
);

export const selectCustomerOrganization = createSelector(
  selectHeaderState,
  (state: IHeaderState) => state?.customerOrganization
);

export const selectCustomerOrganizationId = createSelector(
  selectHeaderState,
  (state: IHeaderState) => state.customerOrganization?.organizationId
);

export const selectCustomerOrganizationCountryId = createSelector(
  selectHeaderState,
  (state: IHeaderState) => state.customerOrganization?.organization.countryId
);

export const selectIsOrganizationChanged = createSelector(
  selectHeaderState,
  (state: IHeaderState) => state.isOrganizationChanged
);

export const selectCustomerOrganizationAddress = createSelector(selectHeaderState, (state: IHeaderState) => {
  if (state.customerOrganization?.organization) {
    return HeaderUtils.getCustomerAddress(state.customerOrganization?.organization);
  }
  return '';
});

export const selectCustomerProfileState = createSelector(
  selectCustomerProfile,
  selectCustomerOrganization,
  selectCustomerOrganizationAddress,
  (
    customerProfile: ICustomerProfileState | null,
    customerOrganization: ICustomerOrganization | null,
    customerOrganizationAddress: string
  ) => {
    return {
      customerProfile,
      customerOrganization,
      customerOrganizationAddress,
    };
  }
);

export const selectCustomerOrganizationAndAddress = createSelector(
  selectCustomerOrganization,
  selectCustomerOrganizationAddress,
  (customerOrganization: ICustomerOrganization | null, customerOrganizationAddress: string) => {
    return {
      customerOrganization,
      customerOrganizationAddress,
    };
  }
);

export const selectCustomerInstitution = createSelector(
  selectCustomerOrganization,
  (state: ICustomerOrganization | null) => (state?.organization.name ? state?.organization.name : '')
);

export const selectCustomerStatus = createSelector(selectCustomerProfile, (state: ICustomerProfileState | null) =>
  state?.customerStatus ? state?.customerStatus : null
);

export const selectCustomerOrganizationAndStatus = createSelector(
  selectOrganizations,
  selectCustomerStatus,
  (customerOrganizations: ICustomerOrganization[] | null, customerStatus: IStatusState | null) => {
    return {
      customerOrganizations,
      customerStatus,
    };
  }
);

export const selectUpdateCustomerStatus = createSelector(
  selectHeaderState,
  (state: IHeaderState) => state.updateCustomerStatus
);
